export default "__VITE_ASSET__DK81FEK8__"